module.exports = __webpack_public_path__ + "static/img/hx_banner.5b1b67d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hx_banner.png
// module id = G+u9
// module chunks = 1